import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { SeoHead } from "@/components/SeoHead";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background">
      <SeoHead
        title="頁面不存在"
        description="您所查閱的頁面不存在或已被移除。請返回首頁繼續瀏覽香港學校招標資訊。"
      />
      <div className="text-center max-w-md mx-4 py-16">
        <p className="text-6xl font-bold text-primary mb-4">404</p>
        <h1 className="text-2xl font-semibold text-foreground mb-3">頁面不存在</h1>
        <p className="text-muted-foreground mb-8">
          您所查閱的頁面不存在或已被移除。
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link href="/">
            <Button>返回首頁</Button>
          </Link>
          <Link href="/tenders">
            <Button variant="outline">瀏覽招標列表</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
